import {createApp} from "vue";
import LatestJobsSlides from "./components/LatestJobsSlides.vue";

createApp({})
    .component("LatestJobsSlides", LatestJobsSlides)
    .mount(".latest-jobs-slides");
